<template>
  <v-dialog v-model="dialogVisible" 
    persistent
    width="100%"
    max-width="360px" 
  >
    <template v-slot:activator="scope">
      <activator-button :scope="scope" />
    </template>

    <v-form @submit.prevent="submitClick" ref="form">
      <v-card>
        <v-card-text>
          <SimpleGoogleAutocomplete
            v-model="address_string"
            outlined dense persistent-placeholder clearable
            hide-details="auto"
            placeholder="Please type your address"
            @placechanged="updateAddressData"
            country="us"
            :rules="[required, full_address]"
          />
          <l-map class="mt-4" ref="theMap" style="height: 220px" :zoom="zoom" :center="center" @ready="mapReady">
            <l-tile-layer :url="url" :attribution="attribution" />
            <l-marker :lat-lng="center" />
          </l-map>
        </v-card-text>

        <v-divider />

        <v-card-actions class="justify-center">
          <v-btn @click="close">Cancel</v-btn>
          <v-btn class="ml-3" color="primary" type="submit">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { latLng } from "leaflet"
import { LMarker, LMap, LTileLayer } from 'vue2-leaflet'
import { ActivatorButton } from '@/components/pages'
import { SimpleGoogleAutocomplete } from '@/components/inputs';

import { mapActions} from 'vuex'
import { required } from '@/lib/validations'

export default {
  name: 'ProContactDialog',

  components: { ActivatorButton, LMarker, LMap, LTileLayer, SimpleGoogleAutocomplete },

  props: ['account'],

  data() {
    return {
      dialogVisible: false,

      zoom: 8,
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',

      address_string: '',

      place_id: '',
      latitude: 30.2672,
      longitude: -97.7431,
      street: '',
      city: '',
      state: '',
      zipcode: '',

      // validation rules
      required,
    };
  },

  computed: {
    center() {
      return latLng(this.latitude, this.longitude)
    },

    // validation rules
    full_address() {
      if (this.place_id && this.street ) return true
      return  'Please choose a full street address'
    },
  },


  watch: {
    dialogVisible(visible) {
      if( visible ) {
        const address = this.account.address

        this.address_string = `${address.street}, ${address.city}, ${address.state}`
        
        this.place_id = address.place_id
        this.latitude = address.latitude || this.latitude
        this.longitude = address.longitude || this.longitude
        this.street = address.street
        this.city = address.city
        this.state = address.state
        this.zipcode = address.zipcode
      }
    },
  },

  methods: {
    ...mapActions('accounts', ['updateMe']),
    
    close() {
      this.dialogVisible = false
    },

    mapReady() {
      // vue2-leaflet doesnt love v-dialog, this is the fix
      this.$refs.theMap.mapObject.invalidateSize()
    },

    updateAddressData(addressData) {          
        this.place_id = addressData.place_id
        this.latitude = addressData.latitude,
        this.longitude = addressData.longitude,
        this.street = addressData.name
        this.city = addressData.locality
        this.state = addressData.administrative_area_level_1
        this.zipcode = addressData.postal_code
    },

    async submitClick() {
      if (this.$refs.form.validate()) {
        const payload = {
          address: {
            place_id: this.place_id,
            coords: `POINT(${this.longitude} ${this.latitude})`,
            street: this.street,
            city: this.city,
            state: this.state,
            zipcode: this.zipcode,
          },
          coverage_radius: this.coverage_radius,
        }

        const result = await this.updateMe(payload)
        if (result.ok) {
          this.close()
        } else {
          this.error_dialog = true
          this.error_message = result.error
        }
      }
    },  
  },
}
</script>

<style scoped>
  .v-dialog__content {
    position:  absolute;
  }
</style>